module.exports = __webpack_public_path__ + "static/media/jezyk_polski.51cc8b25.svg";